import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import { Grid, Card, Button } from '@patomation/react-ui-components'
import find from '@patomation/find'

const PackageList = () => {
  const data = useStaticQuery(graphql`
    query Packages {
      allMarkdownRemark(filter: {fileAbsolutePath: {regex: "//packages//"}}) {
        edges {
          node {
            fields{
              slug
            }
            frontmatter {
              title
              description
              image
              base_price
              person_price
              publish
            }
          }
        }
      }
    }
  `)

  return (
    <Grid className='packagelist' col={3} gap='1rem' style={{justifyItems: 'stretch'}}>
      {find('edges', data).map( (node, index) =>
        find('publish', node)
        ? <Card
          key={`package_${index}`}
          image={find('image', node)}
          alt={find('title', node)}
          middle={<>
            <h2>{find('title',node)}</h2>
            <p>{find('description',node)}</p>
          </>}
          bottom={<>
            {/* TODO <p style={{textAlign: 'center'}}>{find('price',node)}</p><Gutter /> */}


            <Link to={find('slug', node)}>
              <Button
                title='Learn More'
                background='#86AC41' //green
                color='#324851' //dark blue green
                center />
            </Link>
          </>}/>
        : null
      )}
    </Grid>
  )
}
export default PackageList
